import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import './Style.css';

ReactDOM.render(<App />, document.getElementById("root"));
